/* tslint:disable */
/* eslint-disable */
/**
 * Aldebaran API
 * API for reporting progress and fetching user info.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  UserNotesErrorResponse,
  UserNotesRequestQuery,
  UserNotesResponse,
  UserNotesSuccessResponse,
  UserNotesUpdateQuery,
} from '../models/index';
import {
    UserNotesErrorResponseFromJSON,
    UserNotesErrorResponseToJSON,
    UserNotesRequestQueryFromJSON,
    UserNotesRequestQueryToJSON,
    UserNotesResponseFromJSON,
    UserNotesResponseToJSON,
    UserNotesSuccessResponseFromJSON,
    UserNotesSuccessResponseToJSON,
    UserNotesUpdateQueryFromJSON,
    UserNotesUpdateQueryToJSON,
} from '../models/index';

export interface CreateUserNoteRequest {
    userNotesRequestQuery?: UserNotesRequestQuery;
}

export interface DeleteUserNoteRequest {
    id: string;
}

export interface ListUserNotesRequest {
    contentId: string;
}

export interface UpdateUserNoteRequest {
    id: string;
    userNotesUpdateQuery?: UserNotesUpdateQuery;
}

/**
 * 
 */
export class UserNoteApi extends runtime.BaseAPI {

    /**
     */
    async createUserNoteRaw(requestParameters: CreateUserNoteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserNotesResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/usernote`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UserNotesRequestQueryToJSON(requestParameters['userNotesRequestQuery']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserNotesResponseFromJSON(jsonValue));
    }

    /**
     */
    async createUserNote(requestParameters: CreateUserNoteRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserNotesResponse> {
        const response = await this.createUserNoteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async deleteUserNoteRaw(requestParameters: DeleteUserNoteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserNotesSuccessResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteUserNote().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/usernote/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserNotesSuccessResponseFromJSON(jsonValue));
    }

    /**
     */
    async deleteUserNote(requestParameters: DeleteUserNoteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserNotesSuccessResponse> {
        const response = await this.deleteUserNoteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async listUserNotesRaw(requestParameters: ListUserNotesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<UserNotesResponse>>> {
        if (requestParameters['contentId'] == null) {
            throw new runtime.RequiredError(
                'contentId',
                'Required parameter "contentId" was null or undefined when calling listUserNotes().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['contentId'] != null) {
            queryParameters['contentId'] = requestParameters['contentId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/usernote/list`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(UserNotesResponseFromJSON));
    }

    /**
     */
    async listUserNotes(requestParameters: ListUserNotesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<UserNotesResponse>> {
        const response = await this.listUserNotesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async updateUserNoteRaw(requestParameters: UpdateUserNoteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserNotesResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateUserNote().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/usernote/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UserNotesUpdateQueryToJSON(requestParameters['userNotesUpdateQuery']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserNotesResponseFromJSON(jsonValue));
    }

    /**
     */
    async updateUserNote(requestParameters: UpdateUserNoteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserNotesResponse> {
        const response = await this.updateUserNoteRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
